import script from "./SelectAsyncTest.vue?vue&type=script&lang=ts&setup=true"
export * from "./SelectAsyncTest.vue?vue&type=script&lang=ts&setup=true"

import "./SelectAsyncTest.vue?vue&type=style&index=0&id=3c3368ab&lang=scss&scoped=true"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c3368ab"]])

export default __exports__